import React, { useCallback, useContext } from 'react';
import { navigateAction } from 'fluxible-router';
import { capitalize } from 'lodash-es';

import { useArticlePropsById } from '../../hooks/useArticlePropsById';
import FluxibleContext from '../../../../fluxible-context';
import { getSpotId } from '../../../../../services/app-state';
import { Sorting, Folder, MessageType } from '../../../comments-and-posts/state/types';
import styles from './ArticleItemContentTitle.module.scss';

interface IArticleItemContentTitleProps {
  articleId: string;
}

const ArticleItemContentTitle: React.FC<IArticleItemContentTitleProps> = ({ articleId }) => {
  const { title, conversationId } = useArticlePropsById(articleId) ?? {};
  const { executeAction } = useContext(FluxibleContext);

  const handleRedirect = useCallback(() => {
    executeAction(navigateAction, {
      routeName: 'moderation-comments-folders',
      params: {
        spotId: getSpotId(),
        folder: Folder.PENDING,
        tag: MessageType.ALL,
        offset: 0
      },
      query: {
        conversation: conversationId,
        sortBy: Sorting.NEWEST
      }
    });
  }, [conversationId, executeAction]);

  return (
    <div className={styles.container} onClick={handleRedirect}>
      {capitalize(title)}
    </div>
  );
};

export default ArticleItemContentTitle;
